const d = new Date();
export const currentMonthStart = new Date(d.setDate(1));
export const dateRangeStart = new Date(d.setMonth(d.getMonth()));
export const dateRangeEnd = new Date();